import { z } from 'zod';

const nullToUndefined = z
  .string()
  .nullish()
  .transform((v) => v ?? undefined);

export const suggestNextVersionsResponseSchema = z.object({
  nextMajor: z.string().default(''),
  nextMinor: nullToUndefined,
});

export const promoteAppVersionFromDraftResponseSchema = z.object({
  appVersion: z.object({
    fullVersion: z.string().nullish(),
  }),
});

export const getComponentsOverrideResponseSchema = z.object({
  componentsOverride: z.object({
    appId: z.string().optional(),
    externalId: z.string().optional(),
    id: z.string().optional(),
  }),
});

export const getLatestProductionVersionResponseSchema = z.object({
  appVersion: z.object({
    version: z.number(),
  }),
});

export const releaseResponseSchema = z.object({
  releaseBaseUrl: z.string(),
});
